<template>
  <section class="collapser">
    <div class="collapser__header" @click="handleToggleCollapser">
      <!-- <a-icon class="collapser__icon" :type="getArrowIcon" /> -->
      <UpOutlined v-if="expanded" class="collapser__icon" />
      <DownOutlined v-else class="collapser__icon" />
      {{ title }}
    </div>

    <div v-if="expanded" class="collapser__body">
      <slot />
    </div>
  </section>
</template>

<script>
import { UpOutlined, DownOutlined } from "@ant-design/icons-vue";
import { defineComponent } from "vue";
export default defineComponent({
  components: {
    UpOutlined,
    DownOutlined,
  },
  props: {
    title: {
      required: true,
      type: String,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expanded: this.isExpanded,
    };
  },
  computed: {
    getArrowIcon() {
      return this.expanded ? "down" : "right";
    },
  },
  methods: {
    handleToggleCollapser() {
      this.expanded = !this.expanded;
    },
  },
});
</script>

<style lang="sass" scoped>
.collapser
  user-select: none

  &__header
    color: $gray-9
    background-color: $gray-2
    padding: 12px 20px
    margin: 8px 0
    cursor: pointer

  &__body
    margin: 12px 24px

  &__icon
    margin-right: 12px
</style>
